import axios from "axios"

export const getData=async ()=>{
    const res=await axios.get("https://game.shivanegar.ir/api/cats");
    return res.data.categories;
}



// async : این تابع رو ناهمگام میکنه تا بتونیم داخلش از await استفاده کنیم
//با دستور get  داده هایی که داخل api  ما هست در متغییر مییزهres
//به بخش data از پاسخ سرور دسترسی پیدا میکنه از داخل شی فقط فیلد categories  رو که یک ارایه هست برمیگردونه 